export const jsFiles = [
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/ArrayBufferReader.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/ArrayBufferWriter.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/AudioChannel.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/BlobReader.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Client.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Display.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/InputStream.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/IntegerPool.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Keyboard.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Layer.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Mouse.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/OnScreenKeyboard.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/OutputStream.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Parser.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Status.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/StringReader.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/StringWriter.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Tunnel.js",
    "./guacamole-client-eaas/guacamole-common-js/src/main/webapp/modules/Version.js",
];

export const cssFiles = [
    "guacamole-client-eaas/guacamole/src/main/webapp/app/client/styles/keyboard.css",
    "guacamole-client-eaas/guacamole/src/main/webapp/app/osk/styles/osk.css",
];
